/* eslint-disable */

import * as THREE from 'three'

export default {

    vertexShader: `
        #define M_PI 3.1415926535897932384626433832795

        uniform float uElevation;
        uniform float uTime;
        uniform float uSpeed;
        uniform float uSize;
        uniform vec3 uBlur;

        attribute float size;

        varying float vAlpha;
        varying float vBlur;

        void main()
        {
            // New position
            vec3 newPosition = position;

            // Position animation
            newPosition.z = mod(newPosition.z - uTime * uSpeed, - uElevation);

            // Position
            vec4 mvPosition = modelViewMatrix * vec4( newPosition, 1.0 );
            gl_Position = projectionMatrix * mvPosition;

            // Elevation ratio
            float elevationRatio = 1.0 - (1.0 - abs(newPosition.z) / uElevation);

            // Blur
            vBlur = 0.2;

            // Size
            gl_PointSize = uSize;
            gl_PointSize *= ( 300.0 / - mvPosition.z );
            gl_PointSize *= 1.0 + vBlur * uBlur.y;
            gl_PointSize *= 1.0 - elevationRatio * 0.5;
            if( gl_PointSize < 0.0 )
            {
                gl_PointSize = 0.0;
            }

            // Varying alpha
            vAlpha = 1.0;

            if(elevationRatio < 0.1)
            {
                vAlpha = elevationRatio * 1.0 / 0.1;
            }
            else if(elevationRatio > 0.2)
            {
                vAlpha = 1.0 - elevationRatio;
            }
        }

    `,

    fragmentShader: `
        uniform sampler2D texture;
        uniform float uAlpha;
        uniform float uSmoothness;
        uniform vec3 uBlur;
        uniform vec3 uColor;

        varying float vAlpha;
        varying float vBlur;

        void main()
        {
            float dist = sqrt( dot( gl_PointCoord - 0.5, gl_PointCoord - 0.5 ) ) + 0.5;
            float customAlpha = 1.0 - dist;

            float smoothness = uSmoothness;
            smoothness += vBlur * uBlur.z;

            customAlpha = smoothstep( 0.0, smoothness, customAlpha );
            customAlpha *= uAlpha;
            customAlpha *= vAlpha;

            gl_FragColor = vec4( uColor, customAlpha );
        }
    `
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Shaders/PointOfInterestParticles.js